module.exports = __webpack_public_path__ + "static/media/guarantee.77a53123.webp";